import styled from '@emotion/styled';
import { media } from '../../services/media';

export const Wrapper = styled.div`
    max-width: 320px;

    position: relative;
    z-index: 1;

    ${media.min('md')} {
        max-width: 100%;
    }

    ${media.min('lg')} {
        display: flex;
    }
`;
